import React, { useCallback, useEffect, useState } from "react";
import UnityWebViewer from "../components/UnityWebViewer";
import { getOrCreateWebRuntimeSession } from "../services/runtimeSession";
import { VIEWER_SESSION_FAILURE } from "../utils/customerMessages";

const SESSION_REFRESH_SKEW_MS = 60_000;
const MAX_REFRESH_DELAY_MS = 2_147_000_000;

const HomePage = () => {
  const [userData, setUserData] = useState(null);
  const [sessionFailed, setSessionFailed] = useState(false);
  const [sessionAttempt, setSessionAttempt] = useState(0);

  const retrySession = useCallback(() => {
    setSessionFailed(false);
    setSessionAttempt(attempt => attempt + 1);
  }, []);

  useEffect(() => {
    let cancelled = false;
    let refreshTimer = null;
    const refresh = (force = false) =>
      getOrCreateWebRuntimeSession({ force })
        .then(session => {
          if (!cancelled) {
            setUserData(session);
            setSessionFailed(false);
            clearTimeout(refreshTimer);
            const expiresAt = new Date(session.expiresAt).getTime();
            if (Number.isFinite(expiresAt)) {
              const delay = Math.min(
                MAX_REFRESH_DELAY_MS,
                Math.max(1_000, expiresAt - Date.now() - SESSION_REFRESH_SKEW_MS),
              );
              refreshTimer = setTimeout(() => refresh(true), delay);
            }
          }
        })
        .catch(() => {
          if (!cancelled) setSessionFailed(true);
        });

    refresh();
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") refresh();
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      cancelled = true;
      clearTimeout(refreshTimer);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [sessionAttempt]);

  if (sessionFailed) {
    return (
      <div role="alert">
        <p>{VIEWER_SESSION_FAILURE.title}</p>
        {VIEWER_SESSION_FAILURE.detail && (
          <p>{VIEWER_SESSION_FAILURE.detail}</p>
        )}
        <button type="button" onClick={retrySession}>
          Try again
        </button>
      </div>
    );
  }
  if (!userData) {
    return <div role="status">Starting viewer session...</div>;
  }

  return (
    <div className="App">
      <UnityWebViewer
        experienceId="9225a575-dd6c-4774-8ce0-e1a9a778ce11"
        experienceRequestMode="runtime"
        userData={userData}
        completionCtaVariant="default"
        showPlatformSignupCta
      />
    </div>
  );
};

export default HomePage;
